export const corporateRentalDiscountReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_CORPORATE_RENTAL_DISCOUNT_REQUEST":
      return { ...state, loading: true };
    case "ADD_CORPORATE_RENTAL_DISCOUNT_SUCCESS":
      return { ...state, loading: false, addCorporateRentalDiscount: action.payload };
    case "ADD_CORPORATE_RENTAL_DISCOUNT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_CORPORATE_RENTAL_DISCOUNT_REQUEST":
      return { ...state, loading: true };
    case "UPDATE_CORPORATE_RENTAL_DISCOUNT_SUCCESS":
      return { ...state, loading: false, updateCorporateRentalDiscount: action.payload };
    case "UPDATE_CORPORATE_RENTAL_DISCOUNT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "STATUS_CORPORATE_RENTAL_DISCOUNT_REQUEST":
      return { ...state, loading: true };
    case "STATUS_CORPORATE_RENTAL_DISCOUNT_SUCCESS":
      return { ...state, loading: false, statusCorporateRentalDiscount: action.payload };
    case "STATUS_CORPORATE_RENTAL_DISCOUNT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "VIEW_CORPORATE_RENTAL_DISCOUNT_REQUEST":
      return { ...state, loading: true };
    case "VIEW_CORPORATE_RENTAL_DISCOUNT_SUCCESS":
      return { ...state, loading: false, corporateRentalDiscount: action.payload };
    case "VIEW_CORPORATE_RENTAL_DISCOUNT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "LIST_CORPORATE_RENTAL_DISCOUNT_REQUEST":
      return { ...state, loading: true };
    case "LIST_CORPORATE_RENTAL_DISCOUNT_SUCCESS":
      return { ...state, loading: false, corporateRentalDiscountList: action.payload };
    case "LIST_CORPORATE_RENTAL_DISCOUNT_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "RESET_CORPORATE_RENTAL_DISCOUNT":
      return { ...state, corporateRentalDiscount: null, error: null };

    default:
      return state;
  }
};